import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';

import './style.less';

import img1 from '../../static/images/guide/1.jpg';
import img2 from '../../static/images/guide/2.jpg';

class GuidePage extends Component {
    render(){
        return(
            <DocumentTitle title={'新手指南'}>
                <div className="container guide">
                    <div className="section section1">
                        <div className="head">哈佛集训营主题特色</div>
                        <div className="content">
                            <img src={img1} alt="img"/>
                            <div className="text">
                                 爱课英语100%选用哈佛外教，旨在为中国小朋友提供高质量在线主题英语课。
                            </div>
                        </div>
                        <div className="content">
                            <img src={img2} alt="img"/>
                            <div className="text">
                                每天一个主题课程，4名学生分组学习，AI指南教学，人机互动，实现英语加知识1+1教育。
                            </div>
                        </div>
                    </div>
                    <div className="section section2">
                        <div className="head">主题课 - 学习流程</div>
                        <div className="content img1"></div>
                        <div className="content img2"></div>
                        <div className="content img3"></div>
                        <div className="content img4"></div>
                    </div>
                    <div className="section section3">
                        <div className="head">常见问题</div>
                        <div className="content">
                            <p>1. 不同程度的孩子一起上课吗？</p>
                            <p>
                                系统会根据年龄，最大程度的将同年龄段的孩子分配到同一教室。
                            </p>
                            <p>2. 通过上课孩子可以学到什么？</p> 
                            <p>
                                上课内容按照美国儿童地理的主题设置，是典型的通识教育，涉及生命科学、自然地理、音乐文化、哲学宗教、人文艺术等多方位知识，每天一个主题课程，实现英语加知识的1+1教育。
                            </p>
                            <p>3. 何时开始上课？</p> 
                            <p>
                                每天19:30哈佛老师准时开课，凡购买“哈佛外教集训营”套餐的用户，可在有效期内前往上课。在APP上课页，可查看最近7天的课程安排。
                            </p>
                            <p>4. 设备检测有什么用？</p> 
                            <p>
                                上课过程中会占用麦克风和摄像头，课前进行设备检测会保证上课体验。
                            </p>
                            <p>3. 在教室看不到老师和其他学生或经常被踢出教室？</p>
                            <p>
                                请检查设备型号，我们支持的设备型号有：Windows7及以上、iPad mini3及以上、iPhone6及以上、Android5.0及以上设备。
                            </p>
                        </div>
                    </div>
                    <div className="section section4">
                        <div className="head">问题自查与解决</div>
                        <div className="content">
                            <p>如果上课中途出现没声音、卡顿、闪退等问题时，建议按照以下步骤进行尝试：</p>
                            <p>1. 重启APP，重新登录</p>
                            <p>2. 关闭无线路由器，3秒后重新开启无线路由器</p>
                            <p>3. 网络切换至4G尝试</p>
                            <p>4. 检查设备内存是否已满，关闭其他APP进程</p>
                            <p>5. 找到下载地址，重新下载最新版本Air Course</p>
                        </div>
                    </div>
                    <div className="section section5" style={{marginBottom:0}}>
                        <div className="head">注意事项</div>
                        <div className="content">
                            <p>1. 为了保证有良好的上课体验，上课前，请保持上课的设备网络稳定通畅，并且设备内存充足。</p>
                            <p>2. 上课期间，最好不要开启录屏、录音等占用麦克风、摄像头的其他类APP；最好不要打开微信、QQ等有密集通知的APP。</p>
                            <p>3. 为了您和其他人的教学体验，请选择安静的环境进行上课。</p>
                            <p>4. 在上课过程中，会有跟读环节，建议大声读出来或者使用耳麦，不发声会影响评分哦。</p>
                            <p>如有其他疑问，请联系400-8874-877</p>
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

export default GuidePage;



// WEBPACK FOOTER //
// ./src/components/guidePage/GuidePage.jsx